import React, { useState } from "react"

/** Topic intro: up to three grey lines with ellipsis; click to expand or collapse full text. */
export function TopicDescriptionLine({ description }) {
  const [expanded, setExpanded] = useState(false)
  const text = description && String(description).trim()
  if (!text) return null
  const paragraphs = text.split(/\n\n+/).filter(Boolean)

  return (
    <button
      type="button"
      aria-expanded={expanded}
      onClick={() => setExpanded(e => !e)}
      className="mt-2 block w-full min-w-0 cursor-pointer border-0 bg-transparent p-0 text-left text-sm text-gray-500 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400 focus-visible:ring-offset-1 rounded-sm"
    >
      <span
        className={`block w-full min-w-0 ${expanded ? "" : "line-clamp-3"}`}
      >
        {paragraphs.map((paragraph, index) => (
          <span key={index} className={index > 0 ? "mt-2 block" : "block"}>
            {paragraph}
          </span>
        ))}
      </span>
    </button>
  )
}
